module.exports = __webpack_public_path__ + "static/media/buttonX.f2e6bf55.png";